import { useQuery } from '@tanstack/react-query';
import { operationApis } from '../../../../../../../shared/apis/operation/apis';

export default function useNotices({
  queryKey,
  payload,
}: {
  queryKey: (string | number)[];
  payload: {
    page: number;
    size: number;
    search: {
      title: string;
    };
    filter: {
      solutionCd: string;
      noticeCd: string;
    };
  };
}) {
  const { data: noticeList } = useQuery(queryKey, () => operationApis.getNoticeList(payload), {
    select: (data) => data.data,
  });

  return { noticeList };
}
